import { render } from "./NaszeOdpowiedzi.vue?vue&type=template&id=0be030ff&scoped=true"
import script from "./NaszeOdpowiedzi.vue?vue&type=script&lang=js"
export * from "./NaszeOdpowiedzi.vue?vue&type=script&lang=js"

import "./NaszeOdpowiedzi.vue?vue&type=style&index=0&id=0be030ff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0be030ff"]])

export default __exports__